/** Colorado e-bike tax credit — Colorado HB23-1272, effective 2024–2032.
 * Current 2026 amount: $225 discount per e-bike, limited to ONE discount per
 * Colorado resident per CALENDAR YEAR (not every 24 months). Applied instantly
 * at the counter by a participating retailer; the retailer claims a $250 state
 * income tax credit. Front Range Cargo Bikes is on the state's participating
 * retailer list.
 *
 * SOURCE (verified 2026-08-06):
 *   https://energyoffice.colorado.gov/ebike-tax-credit
 *   "Amount: $225 discount per e-bike (limited to one discount a year per
 *    resident); $250 tax credit for retailer"
 *   https://tax.colorado.gov/electric-bicycle-tax-credit
 *   Retailer list (FRCB row confirmed):
 *   https://docs.google.com/spreadsheets/d/1VTb1sOUb5He3iUdHTwBWngxP-MbhpuilPgDQ8RMBKGI
 *
 * TODO(Ryan): update if the state changes the credit amount.
 */
export const CO_TAX_CREDIT = 225;

/** Official Colorado Energy Office page for the $225 point-of-sale e-bike tax
 * credit discount. Verified live 2026-08-06 (HTTP 200). Use this as the
 * authoritative outbound link anywhere the site states the $225 amount. */
export const CO_TAX_CREDIT_URL = "https://energyoffice.colorado.gov/ebike-tax-credit";

/** Colorado's income-qualified e-bike REBATE — a separate program from the
 * $225 tax credit discount above, and stackable with it at retailers
 * participating in both (Front Range Cargo Bikes is on both state lists).
 *
 * Base rebate $1,000, plus $300 more for a qualifying e-cargo bike, plus $300
 * for an adaptive e-bike. Registration is a LOTTERY: register during an open
 * window, CEO randomly selects, selected registrants have one week to upload
 * proof of income + Colorado address, then 60 days to redeem at a participating
 * retailer. One lifetime rebate per person.
 *
 * SOURCE (verified 2026-08-06): https://energyoffice.colorado.gov/ebike-rebates
 */
export const CO_REBATE_BASE = 1000;
export const CO_REBATE_CARGO_BONUS = 300;
export const CO_REBATE_ADAPTIVE_BONUS = 300;

/** Max a Colorado buyer can take off a qualifying e-CARGO bike at Front Range:
 * $1,000 base rebate + $300 e-cargo bonus + $225 tax-credit discount = $1,525.
 * Requires being selected in the rebate lottery AND meeting income eligibility.
 * Do NOT present this number as available to everyone. */
export const CO_MAX_CARGO_STACK =
  CO_REBATE_BASE + CO_REBATE_CARGO_BONUS + CO_TAX_CREDIT;

/** Official Colorado Energy Office rebate page. Verified live 2026-08-06. */
export const CO_REBATE_URL = "https://energyoffice.colorado.gov/ebike-rebates";

/** Direct link to the rebate registration portal (opens only during a window). */
export const CO_REBATE_PORTAL_URL = "https://coloradoebikerebates.aptracks.com/";

/** Rebate registration windows published by the Colorado Energy Office.
 * Each window opens 11:00 AM MT on the start date and closes 12:00 PM MT on
 * the end date. SOURCE: https://energyoffice.colorado.gov/ebike-rebates
 * (verified 2026-08-06). ISO dates so the UI can compare against `new Date()`
 * and show the next open window without anyone hand-editing copy.
 *
 * TODO: CEO publishes new windows roughly annually — extend this list when
 * they announce beyond March 2027.
 */
export const CO_REBATE_WINDOWS: ReadonlyArray<{ opens: string; closes: string }> = [
  { opens: "2026-08-24T11:00:00-06:00", closes: "2026-08-31T12:00:00-06:00" },
  { opens: "2026-10-19T11:00:00-06:00", closes: "2026-10-26T12:00:00-06:00" },
  { opens: "2027-01-11T11:00:00-07:00", closes: "2027-01-18T12:00:00-07:00" },
  { opens: "2027-03-15T11:00:00-06:00", closes: "2027-03-22T12:00:00-06:00" },
];

/** Ryan's first cargo-bike build — an Xtracycle conversion, the only
 * attested origin date. The "shop founded in 2004" claim that previously
 * appeared on the site is NOT confirmed in any source; use this constant
 * with phrasing like "Cargo bikes since 2003" rather than "Shop since 2003".
 * SOURCE: Granola 2025-12-09 Ryan call — "It was 2003 when I bought my
 * personal first [Xtracycle]".
 */
export const FOUNDING_YEAR = 2003;
